<template lang="jade">
  div.Autosuggest
    div.Autosuggest__input
      div.Input(":tooltip"="fdata.tip"
                v-bind:class="{'Input--filled': query, 'Input--invalid': error, 'Input--valid': complete}"
                ":skin"="skins.inputs")
        input.Input__field(type="text"
                           v-model="query"
                           @keyup.38="cycleUp"
                           @keyup.40="cycleDown"
                           @keypress.enter.prevent="search({})")
        label.Input__label
          span.Input__label-content {{ fdata.label }}
      ul.Autosuggest__list(v-show="loading || items.length")
        li.Autosuggest__loading(v-if="loading"
                                class="animate"
                                transition="fade")
          span.Autosuggest__spinner
            i(class="fa fa-spinner fa-spin fa-2x fa-fw")
        li.Autosuggest__item(v-for="item in items"
                             v-if="!loading"
                             @click="item.action(item)") {{ item.line }}
    div.Autosuggest__action
      button.Button.Button--primary(type="button"
                                    ":skin"="skins.buttons"
                                    @click="search({})"
                                    style="min-width: 140px")
        span.Button__text Find Address
  div.Action(v-show="!manual"
      @click="manual = true") Enter your address manually
  div(v-show="manual")
    component(v-for="field in fields"
            ":is"="field.type"
            ":fdata"="field")
</template>
<script>
  import _ from 'lodash'
  import { Address } from 'src/services/resources'
  import { addNotification,
           removeNotification } from 'src/vuex/actions'
  import { skins,
           forms,
           config,
           workflow } from 'src/vuex/getters'

  export default {
    data () {
      return { loading: false,
               uid: this.$parent.uid,
               items: [],
               fields: [],
               query: '',
               error: false,
               complete: false,
               manual: false,
               addr: {} }
    },

    props: {
      fdata: { type: Object,
               coerce: val => val.editable ? val : _.set(val, 'field', false) }
    },

    vuex: {
      getters: { skins,
                 forms,
                 workflow,
                 config },
      actions: { addNotification,
                 removeNotification }
    },

    components: {
      'dynamic-input': require('../dynamic/input')
    },

    computed: {
      form () {
        return _.find(this.forms, ['uid', this.uid])
      }
    },

    methods: {
      isValid () {
        let validated = this.computedValidate(this.fdata, this.query)
        this.fieldState(validated)
        if (validated !== null) {
          this.notice('error', validated)
          return false
        }
        return true
      },

      fieldState (valid) {
        if (this.attempts < 1) return false
        _.isNil(valid) ? this.setFieldComplete() : this.setFieldError()
      },

      setFieldComplete () {
        this.$set('complete', true)
        this.$set('error', false)
      },

      setFieldError () {
        this.$set('error', true)
        this.$set('complete', false)
      },

      manualEntry () {
        this.$set('fdata.disableManualInput', false)
        this.$set('manual', true)
        this.reset()
      },

      mapValues (coll) {
        let m = _.map(coll, xs => xs.fields ? _.set(xs, 'fields', this.multiValue(xs))
                                            : this.singleValue(xs))
        return Object.assign({}, m)
      },

      multiValue (n) {
        return _.map(n.fields, xs => _.set(xs, 'value', this.addr[xs.field] || ''))
      },

      singleValue (n) {
        return _.set(n, 'value', this.addr[n.field])
      },

      search (q) {
        if (!this.isValid()) return false
        let { id = '' } = q
        this.$set('loading', true)
        Address.find(this.params(id), {})
          .then(this.process)
          .then(this.setList)
          .catch(this.fail)
      },

      process (res) {
        let coll = res.data.data.returnValue.addresses
        if (_.isEmpty(coll)) this.notice('error', this.fdata.messages.noResults)
        return _.map(coll, x => _.set(x, 'action', x.more ? this.search : this.fetch))
      },

      fetch (q) {
        let {id = '', line = ''} = q
        Address.fetch(this.params(id, line), {})
          .then(this.dispatch)
          .then(this.reset)
          .catch(this.fail)
      },

      notice (type, msg) {
        this.addNotification({type: type,
                              msg: [msg],
                              id: _.uniqueId(),
                              timeout: 7000,
                              onComplete: 'remove',
                              show: true})
      },

      dispatch (res) {
        this.$set('fdata.disableManualInput', false)
        let addr = _.mapKeys(res.data.data.returnValue,
                             (v, k) => this.fdata.fields[k])
        this.$set('addr', addr)
        let values = this.mapValues(this.fields)
        // this.$set('fields', values)
        this.$broadcast('fdata::set', values)
        this.$broadcast('set', addr)
        this.manual = true
        this.$dispatch('fdata::group', addr)
      },

      fail (res) {
        switch (res.status) {
          case 400:
          case 500:
            this.notice('error', this.fdata.messages.serviceUnavailable)
            this.setList([])
            break
          default:

        }
      },

      reset () {
        this.$set('items', [])
        this.$set('query', '')
      },

      setList (coll) {
        coll.push({ line: this.fdata.messages.manualEntryResult,
                    action: this.manualEntry })
        this.$set('items', coll)
        this.$set('loading', false)
      },

      params (id = '', searchTerm = false) {
        let params = _.find(this.workflow, ['uid', this.uid])
        let DTO = { siteId: params.sid,
                    clientHost: 'client.machine.blueyonder.co.uk',
                    workflowId: this.fdata.workflowId,
                    id: id,
                    searchTerm: searchTerm || this.query,
                    service: this.fdata.service }

        return Object.assign({}, DTO, searchTerm ? { resultProcess: 'personal' }
                                                 : { secondary: id !== '' })
      }
    },
    ready () {
      let target = _.find(this.form.targets, ['type', this.fdata.target])
      this.$set('fields', target.content)
      target.content.forEach(xs => {
        switch (xs.type) {
          case 'type_multiText':
            if (_.some(xs.fields, x => !_.isNil(x.value) && !_.isEmpty(x.value))) {
              this.$set('manual', true)
            }
            break
          case 'type_text':
            if (!_.isNil(xs.value) && !_.isEmpty(xs.value)) {
              this.$set('manual', true)
            }
            break
        }
      })
    }

  }
</script>



// WEBPACK FOOTER //
// lookup.vue?49297b21